import React from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";

// Sortable answer item
const SortableItem = SortableElement(({ question }) => (
  <div>
    <div className="mt-2">{question.title}</div>
    <hr></hr>
  </div>
));

const SortQuestions = SortableContainer(({ questions }) => {
  return (
    <div>
      {questions.map((question, index) => (
        <SortableItem key={`item-${index}`} index={index} question={question} />
      ))}
    </div>
  );
});

export default SortQuestions;
